import {SocketConnector} from './base_connector/socket_connector';

/**
 *  Note this file automatically generated from
 *  @link http://gitlab.fimacomarketing.com:10080/ProninE/BGServerGame/tree/master/ServerPHP/daemon/daemon_node/public/site/connectors/PlayerConnector.js
 */

(function (global) {
'use strict';


var PlayerConnector = function(socket) {
    SocketConnector.call(this, socket);
    this.verbose_name = "PlayerConnector:";
    this.controller_id = "player-rpc";

    var self = this;

    this.TYPE_ID_PERSON  = 1;
    this.TYPE_ID_BOT     = 2;
    this.TYPE_ID_ADMIN   = 10;
    this.TYPE_ID_ROOT    = 20;

    self.my_uuid = null;

    this.operation_type = {
        TYPE_ID_INPUT           : 10,
        TYPE_ID_INPUT_DEMO      : 11,
        TYPE_ID_OUTPUT          : 20,
        TYPE_ID_TRANSFER        : 30,
        TYPE_ID_TRANSFER_GAME_BET    : 32, // game_uuid
        TYPE_ID_TRANSFER_GAME_RETURN : 34, // game_uuid
        TYPE_ID_TRANSFER_GAME_WIN    : 36, // game_uuid
        TYPE_ID_TRANSFER_TOURNAMENT_BET    : 40, // tournament_uuid
        TYPE_ID_TRANSFER_TOURNAMENT_RETURN : 41, // tournament_uuid
        TYPE_ID_TRANSFER_TOURNAMENT_WIN    : 42, // tournament_uuid
        TYPE_ID_X_CHANGE : 60,
        TYPE_ID_SYSTEM_GIFT : 70,
        TYPE_ID_SYSTEM_TRADE : 80,
        TYPE_ID_RATE : 100,
        TYPE_ID_MINIGAME_BET : 200,
        TYPE_ID_MINIGAME_WIN : 201
    };

    this.cb_account_select           = function(data)  {self.cb_account_changed_selected(data); };
    this.cb_account_changed_selected = function(data)  {self.__log("cb_account_changed_selected not used", data); };
    this.cb_account_changed_any      = function(data)  {self.__log("cb_account_changed_any not used", data); };
    this.cb_unauthorised             = function (data) {self.__log("cb_unauthorised not used", data); };

    this.__setupCallbacks();
};

PlayerConnector.prototype = Object.create(SocketConnector.prototype);
PlayerConnector.prototype.constructor = PlayerConnector;

PlayerConnector.prototype.__setupCallbacks = function() {
    var self = this;

    this.socket.on("accountChanged", function(data) {
        self.__log("accountChanged", data);
        self.cb_account_changed_any(data);
        if(data.account === undefined)
            return;
        if(!data.account.isSelectedByPlayer) {
            self.__log("Not active account changed!");
            return;
        }

        self.__log("accountChangedSelected", data);
        self.cb_account_changed_selected(data);
    });

    this.socket.on("user_info", function(data) {
        self.my_uuid   = data.uuid;
    });

    this.socket.on("accountSelected", function(data) {
        self.__log("accountSelected", data);
        self.cb_account_select(data);
    });

    this.socket.on("unauthorised", function(data) {
        self.__log("unauthorised", data);
        self.cb_unauthorised(data);
    });


    //this.socket.on("connected")
};

PlayerConnector.prototype.doGetTopRating = function(limit,cb) {
    this.__call("get-top-rating", {limit:limit} , cb);
};

PlayerConnector.prototype.doGetTopGamesWin = function(limit,cb) {
    this.__call("get-top-games-win", {limit:limit} , cb);
};

PlayerConnector.prototype.__onUnauthorised = function(data) {
    this.cb_unauthorised(data);
};

/**
 * Get detail information about player
 * @param uuid
 * @param cb
 */
PlayerConnector.prototype.doView = function(uuid ,cb) {
    this.__call("view", {uuid:uuid} , cb);
};




/**
 * Get detail information about player
 * @param {string[]}extra_fields
 * @param cb
 */
PlayerConnector.prototype.doViewSelf = function( extra_fields ,cb) {
    this.__call("view-self", {extra_fields:extra_fields} , cb);
};

/**
 * setSettings of player
 *  @param settings {Object}
 *  @param settings.avatar_type  @see \frontend\models\ProfileSettingsForm::$AVATAR_TYPE_VARIANTS
 *  @param settings.color
 *  @param settings.skin_type
 *  @param settings.feature_auto_dice
 *  @param settings.feature_double_click_move_type
 *  @param settings.feature_auto_bearing_off
 *
 * @param cb
 */
PlayerConnector.prototype.doSetSettings = function( settings ,cb) {
    this.__call("set-settings", settings , cb);
};


/**
 * get player statistics
 * @param params
 * @param cb
 */
PlayerConnector.prototype.doGetStatistics = function( params ,cb) {
    this.__call("get-statistics", params , cb);
};


/**
 * Callback when your money account changed
 *  Обратный вызов когда текущий счет меняет значение или меняется выбранный счет
 *   Если изменеие счета в результате операции то будет data.delta
 *
 * Применять для отображения актуального состояния в заголовке сайта
 *
 * @param cb function(data)
 *        data.account {object}    new account state - use this if you need just redraw
 *        data.account.value
 *        data.account.currency
 *        data.delta   {Object|undefined}     describe the change of account if account changed by operation
 *        data.delta.value_delta
 *        data.delta.value_after
 */
PlayerConnector.prototype.setCallbackAccountChangedSelected = function(cb) { this.cb_account_changed_selected = cb; };

/**
 *   Обратный вызов когда любой счет игрока  меняет значение
 *   Применять при отображениии списка акаунтов игрока
 *   @param cb function(data)
 */
PlayerConnector.prototype.setCallbackAccountChangedAny = function(cb) { this.cb_account_changed_any = cb; };


/**
 *   Обратный вызов когда любой счет игрока  меняет значение
 *   Применять при отображениии списка акаунтов игрока
 *   @param cb function(data)
 */
PlayerConnector.prototype.setCallbackOnUnauthorised = function(cb) { this.cb_unauthorised = cb; };

global.PlayerConnector = PlayerConnector; 

}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/minigame_client/support_connectors/player_connector.js
// module id = 124
// module chunks = 0